import { normalizeCounter } from "components/StaffingLevels/staffingNeedGrid";

export const RESTRICTION_FIELDS = [
	"max_daily_working_hours",
	"min_rest_hours_between_blocks",
	"max_rest_hours_between_blocks",
	"max_number_of_blocks",
];

const REST_WINDOW_FIELDS = [
	"rest_window_between_blocks_start",
	"rest_window_between_blocks_end",
];

export function cloneRestrictionConfig(config) {
	return (config || []).map((item) => ({ ...item }));
}

export function restrictionItemHasValues(item) {
	if (!item) return false;
	if (RESTRICTION_FIELDS.some((field) => normalizeCounter(item[field]) > 0)) return true;
	return REST_WINDOW_FIELDS.some((field) => !!item[field]);
}

export function restrictionSignature(config) {
	return JSON.stringify(
		(config || [])
			.map((item) => ({
				id: item.id || null,
				day_type_id: item.day_type_id,
				max_daily_working_hours: normalizeCounter(item.max_daily_working_hours),
				min_rest_hours_between_blocks: normalizeCounter(item.min_rest_hours_between_blocks),
				max_rest_hours_between_blocks: normalizeCounter(item.max_rest_hours_between_blocks),
				max_number_of_blocks: normalizeCounter(item.max_number_of_blocks),
				rest_window_between_blocks_start: item.rest_window_between_blocks_start || "",
				rest_window_between_blocks_end: item.rest_window_between_blocks_end || "",
			}))
			.sort((a, b) => Number(a.day_type_id) - Number(b.day_type_id))
	);
}

export function readRestriction(config, field, dayTypeId) {
	const item = (config || []).find((entry) => entry.day_type_id === dayTypeId);
	return item ? normalizeCounter(item[field]) : 0;
}

export function restrictionPeak(config) {
	return (config || []).reduce((peak, item) => {
		const rowPeak = RESTRICTION_FIELDS.reduce(
			(max, field) => Math.max(max, normalizeCounter(item[field])),
			0
		);
		return Math.max(peak, rowPeak);
	}, 0);
}

export function applyRestrictionUpdates(config, updates) {
	const next = cloneRestrictionConfig(config);

	(updates || []).forEach((update) => {
		if (!RESTRICTION_FIELDS.includes(update.field)) return;
		const dayTypeId = update.dayTypeId;
		const numeric = normalizeCounter(update.value);
		const index = next.findIndex((item) => item.day_type_id === dayTypeId);
		const item = index >= 0 ? { ...next[index] } : { day_type_id: dayTypeId };

		if (numeric <= 0) delete item[update.field];
		else item[update.field] = numeric;

		if (restrictionItemHasValues(item)) {
			if (index >= 0) next[index] = item;
			else next.push(item);
		} else if (index >= 0) {
			next.splice(index, 1);
		}
	});

	return next;
}
